<template>
    <div class="anthropometrics-list">

        <b-card no-body>
            <b-card-header>
                <div class="float-right">
                    <anthropometrics-edit-modal :participantId="participant.id">
                    </anthropometrics-edit-modal>
                </div>
                <h5 class="float-left">
                    {{ $i18n.gt('HEADING_ANTHROPOMETRICS') }}
                </h5>
                <div class="float-left ml-5">
                    <b-form-checkbox switch
                                     v-model="showOlder"
                                     v-if="values.length > 0">
                        {{ $i18n.gt('LABEL_SHOW_OLDER_VALUES') }}
                    </b-form-checkbox>
                </div>
            </b-card-header>
            <table class="table table-striped">
                <template v-for="(a,i) in values">
                    <tr v-if="!!a" :key="i">
                        <th>
                            <timestamp :date="a.updated"></timestamp>
                        </th>
                        <td>
                            {{ a.comment }}
                        </td>
                        <td>
                            <anthropometrics-summary :anthropometrics="a"
                                                     :show-values="true">
                            </anthropometrics-summary>
                        </td>
                    </tr>
                </template>
            </table>
        </b-card>

    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue'
import * as _ from 'lodash'

/**
 * A list of Anthropometrics records for the current patient
 */
export default Vue.extend({
    name: 'AnthropometricsList',
    data() {
        return {
            showOlder: false
        }
    },
    computed: {
        participant() {
            return this.$store.state.patientParticipant
        },
        values() {
            const list = this.participant.latestAnthropometrics
            if (this.showOlder) {
                return list
            } else if (list && list.length > 0) {
                return [_.head(list)]
            } else {
                return []
            }
        }
    }
})

</script>
